import { Box, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import ImportPerformanceDialog from "./ImportPerformanceDialog";
import { ImportedPerformanceHistoryData } from "../../templates/Performance";
import ExportPerformancesExcelAndCsvButton from "./ExportPerformancesExcelAndCsvButton";

interface Props {
  performanceHistories: ImportedPerformanceHistoryData[];
  render: boolean;
  setRender: Dispatch<SetStateAction<boolean>>;
  setResMsg: Dispatch<SetStateAction<string>>;
  setIsSuccess: Dispatch<SetStateAction<boolean>>;
}

export function PerformanceBar(props: Props) {
  const { performanceHistories, render, setRender, setResMsg, setIsSuccess } =
    props;
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        m: 1,
        mb: 1,
      }}
    >
      <Typography sx={{ m: 1 }} variant="h5">
        Performance
      </Typography>
      <Box
        sx={{
          alignItems: "right",
          display: "flex",
        }}
      >
        <ExportPerformancesExcelAndCsvButton
          rows={performanceHistories}
          exportType="csv"
          setResMsg={setResMsg}
          setIsSuccess={setIsSuccess}
        />
        <ExportPerformancesExcelAndCsvButton
          rows={performanceHistories}
          exportType="xlsx"
          setResMsg={setResMsg}
          setIsSuccess={setIsSuccess}
        />
        <ImportPerformanceDialog
          render={render}
          setRender={setRender}
          setResMsg={setResMsg}
          setIsSuccess={setIsSuccess}
        />
      </Box>
    </Box>
  );
}
